export default __webpack_public_path__ + "static/media/photo--sm--misc-13.af03e07c.jpg";